import "core-js/modules/es.array.push.js";
var state = {
  logs: []
};
var mutations = {
  ADD_ERROR_LOG: function ADD_ERROR_LOG(state, log) {
    state.logs.push(log);
  }
};
var actions = {
  addErrorLog: function addErrorLog(_ref, log) {
    var commit = _ref.commit;
    commit('ADD_ERROR_LOG', log);
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};